import { MenuStatus } from 'types/menu.type';
import { StoreFinderResponse } from 'api/stores/types';
import { getPlatformAPIUrl } from 'utils/platform-api-url';
import { getTPAPIKey, getTPAPIUrl } from 'utils/tp-api-url';
import axios from 'axios';

class StoresApiService {
  async getAllStores(): Promise<StoreFinderResponse> {
    const url = getPlatformAPIUrl();
    const response = await axios.get<StoreFinderResponse>(
      `${url}/stores/store-finder/get-stores?latitude=0&longitude=0`,
    );

    return response.data;
  }

  async getAllStoresStatus(): Promise<MenuStatus[]> {
    const url = getTPAPIUrl();
    const header = {
      'Ocp-Apim-Subscription-Key': getTPAPIKey(),
    };
    const vendor = window.location.pathname.includes('door-dash')
      ? 'doordash'
      : 'ubereats';

    const response = await axios.get<MenuStatus[]>(
      `${url}/${vendor}/menu/stores/status`,
      { headers: header },
    );

    return response.data;
  }
}

const storesService = new StoresApiService();

export { storesService };
